import ConfidentialitySection from 'app/src/help/components/ConfidentialitySection'
import CookiesPolicySection from 'app/src/help/components/CookiesPolicySection'
import CustomerSupportSection from 'app/src/help/components/CustomerSupportSection'
import DSSGuidesSection from 'app/src/help/components/DSSGuidesSection'
import LegalNoticeSection from 'app/src/help/components/LegalNoticeSection'
import NeedHelp from 'app/src/help/components/NeedHelp'
import Scrollable from 'app/src/kit/Scrollable'
import HeaderActions from 'app/src/layouts/HeaderActions'

const HelpScreen = () => {
  return (
    <>
      <HeaderActions />
      <Scrollable $maxWidth={980} $mx={'auto'} $p={'lg'}>
        <NeedHelp />
        <CustomerSupportSection />
        <DSSGuidesSection />
        <LegalNoticeSection />
        <ConfidentialitySection />
        <CookiesPolicySection />
      </Scrollable>
    </>
  )
}

export const Component = HelpScreen
export default HelpScreen
